import {GA_DISABLED} from "./Constants";

function SetGAConfig (userId) {
    if (GA_DISABLED) {
        return;
    }

    const gtag = window.gtag;
    if (gtag) {
        gtag('set', {'user_id': userId + ''});
    }
}

export default SetGAConfig;



// WEBPACK FOOTER //
// ./src/utils/SetGAConfig.js